<template>
  <div class="list-cards">
    <vxe-table :data="items" border class="list-table">
      <vxe-table-column title="USER" min-width="200">
        <template #default="{ row }">
          <div class="approver-name">
            <strong>{{ row.userName }}</strong>
          </div>
          <div class="approver-id">({{ row.userApmId }})</div>
        </template>
      </vxe-table-column>
      <vxe-table-column title="L1 APM ID" min-width="180">
        <template #default="{ row }">
          <div class="approver-name">
            <strong>{{ row.l1ApmId }}</strong>
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column title="L2 APM ID" min-width="180">
        <template #default="{ row }">
          <div class="approver-name">
            <strong>{{ row.l2ApmId }}</strong>
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column title="SITE LEADER APM ID" min-width="180">
        <template #default="{ row }">
          <div class="approver-name">
            <strong>{{ row.siteLeaderApmId }}</strong>
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column
        title="EDIT"
        min-width="85"
        align="center"
        fixed="right">
        <template #default="{ row }">
          <span>
            <button
              :class="['icon-button', { disabled: !getIsSupport }]"
              :disabled="!getIsSupport"
              @click="onEditUser(row)">
              <svg
                class="edit-icon"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.33301 2.66602H2.66634C2.31272 2.66602 1.97358 2.80649 1.72353 3.05654C1.47348 3.30659 1.33301 3.64573 1.33301 3.99935V13.3327C1.33301 13.6863 1.47348 14.0254 1.72353 14.2755C1.97358 14.5255 2.31272 14.666 2.66634 14.666H11.9997C12.3533 14.666 12.6924 14.5255 12.9425 14.2755C13.1925 14.0254 13.333 13.6863 13.333 13.3327V8.66602"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  d="M12.333 1.66617C12.5982 1.40095 12.9579 1.25195 13.333 1.25195C13.7081 1.25195 14.0678 1.40095 14.333 1.66617C14.5982 1.93138 14.7472 2.29109 14.7472 2.66617C14.7472 3.04124 14.5982 3.40095 14.333 3.66617L7.99967 9.9995L5.33301 10.6662L5.99967 7.9995L12.333 1.66617Z"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </button>
          </span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        title="DELETE"
        min-width="85"
        align="center"
        fixed="right">
        <template #default="{ row }">
          <span>
            <button
              :class="['icon-button', { disabled: !getIsSupport }]"
              :disabled="!getIsSupport"
              @click="onDeleteUser(row)">
              <svg
                class="delete-icon"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.3327 7.5V15.8333H6.66602V7.5H13.3327ZM12.0827 2.5H7.91602L7.08268 3.33333H4.16602V5H15.8327V3.33333H12.916L12.0827 2.5ZM14.9994 5.83333H4.99935V15.8333C4.99935 16.75 5.74935 17.5 6.66602 17.5H13.3327C14.2494 17.5 14.9994 16.75 14.9994 15.8333V5.83333Z" />
              </svg>
            </button>
          </span>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
import { statusMapping } from "@/config/constant";
import { format } from "date-fns";
import { mapGetters } from "vuex";

// Constants
import { approverManagementConstants } from "@/config/constant";

export default {
  name: "ApproversTable",
  components: {
    // Icon,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    userHasNotAccess: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      statusMapping,
      approverManagementConstants: approverManagementConstants,
    };
  },
  computed: {
    ...mapGetters(["getIsSupport"]),
  },
  methods: {
    format,
    onEditUser(row) {
      this.$emit("handleEditUser", row);
    },
    onDeleteUser(row) {
      this.$emit("handleDeleteUser", row);
    },
    getValues(val) {
      if (Array.isArray(val)) {
        return val.join(", ");
      }

      return val;
    },
    getClusterValue(val) {
      let clusterNames = val.map((item) => {
        return item.areaName;
      });
      var filteredArray = clusterNames.filter(function (item, pos) {
        return clusterNames.indexOf(item) == pos;
      });
      return filteredArray.join(", ");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/imports";

.list-table {
  width: 100%;
  font-size: 0.75rem;
  color: var(--secondary-text);
  font-family: "Maersk Headline";
  .vxe-body--column,
  .vxe-header--column {
    background-image: -webkit-gradient(
        linear,
        left top,
        left bottom,
        from(#cfcfcf),
        to(#cfcfcf)
      ),
      -webkit-gradient(linear, left top, left bottom, from(#cfcfcf), to(#cfcfcf)) !important;
    background-image: linear-gradient(#cfcfcf, #cfcfcf),
      linear-gradient(#cfcfcf, #cfcfcf) !important;
  }
  .vxe-body--row {
    background-color: var(--card-bg);
  }
  .vxe-cell--title {
    font-family: "Maersk Text";
  }
  .vxe-body--column {
    z-index: 1;
    .vxe-cell {
      font-family: "Maersk Text";
    }
  }
  .vxe-header--column {
    .vxe-cell--title {
      font-family: "Maersk Headline Bold";
    }
  }
}

.list-cards {
  width: 100%;
  display: flex;
  border-radius: 4px;
  border: 1px solid var(--card-border);
  margin-bottom: 24px;

  & .action_button_area {
    width: 320px;
    & .actionButton {
      width: 290px;
    }
  }
  .approver-name {
    strong {
      font-size: 12px;
      font-family: "Maersk Headline";
    }
  }

  & .list-header {
    background-color: var(--alt-color);
  }

  & .row--stripe {
    background-color: red;
  }

  & .title {
    font-family: "Maersk Headline Bold";

    &.requestClarification {
      color: var(--request-clarification-bg);
    }

    &.pendingApproval {
      color: var(--pending-approval-bg);
    }

    &.approved {
      color: var(--approved-bg);
    }

    &.denied {
      color: var(--denied-bg);
    }
  }
}

.icon-button {
  padding: 0;
  border: 0;
  cursor: pointer;
  background: none;
}
.disabled {
  cursor: not-allowed;
}

.delete-icon {
  fill: #000;
  stroke: none;
}

.edit-icon {
  stroke: #000;
  fill: none;
}
</style>

<style lang="scss">
.list-table {
  color: #000;
  font-family: "Maersk Headline";

  .vxe-cell--title {
    font-weight: normal;
  }
  & .vxe-header--row {
    font-family: "Maersk Headline Bold";
    background-color: var(--dashboard-table-background);
  }

  & .vxe-table--body-wrapper,
  .vxe-table--footer-wrapper {
    background-color: var(--layout-bg);
    font-family: "Maersk Headline";
  }
}
</style>
